import { render, staticRenderFns } from "./recruit_list.vue?vue&type=template&id=011fafd6"
import script from "./recruit_list.vue?vue&type=script&lang=js"
export * from "./recruit_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports